export default class ClearExternalCustomerSearchResults {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.externalCustomerSearchResults.remove();
  }
}
